module.exports = __webpack_public_path__ + "img/GppBadOutlined.381e570a.svg";